module.exports = __webpack_public_path__ + "img/cruise-distance.ae79869c.svg";